module.exports = __webpack_public_path__ + "media/images/correct-sign-0bf7740952d793a154b68ea807c1d25d.png";